module.exports = __webpack_public_path__ + "static/img/core-bg-02.e48f1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/core-bg-02.png
// module id = cTUm
// module chunks = 1